import { createContext, useEffect, useState } from "react";







export const authContext = createContext();
 



export function AuthProvider({ children }) {
    

    const [token,setToken]= useState(null)
    const [user, setUserInfo] = useState(null);

    useEffect(function () {
        if (localStorage.getItem('tkn') !== null) {
            setToken(localStorage.getItem('tkn'))
            
        }
       
    
   },[])




    return <authContext.Provider value={{token,setToken,user,setUserInfo}}>
    
        {children}
    
    
    </authContext.Provider>
    
}